import { motion } from "framer-motion";

export default function Home() {
  return (
    <motion.main
      data-testid="home-page"
      className="pt-14"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="w-full">
        <motion.img
          src="/images/studio-7.webp"
          alt="Vison Studios stacked daisy caps"
          data-testid="home-hero-image"
          className="h-[calc(100dvh-3.5rem)] w-full object-cover"
          initial={{ opacity: 0, scale: 1.02 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          draggable="false"
        />
      </div>
    </motion.main>
  );
}
